import { render, staticRenderFns } from "./PatternExtension3Form.vue?vue&type=template&id=dcb3c870&"
import script from "./PatternExtension3Form.vue?vue&type=script&lang=js&"
export * from "./PatternExtension3Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports